import PortalIdParser from 'PortalIdParser';
export const getBrandIdentityUrl = ({
  tab,
  businessUnitId = 0
}) => {
  const url = `/settings/${PortalIdParser.get()}/brand-identity/brand/${businessUnitId}`;
  if (tab) {
    return `${url}/${tab}`;
  }
  return url;
};